import { TypeHeritageInteractor, TypeHeritageRequest, TypeHeritageStructRequest} from "../../Coordinator/TypeHeritage/TypeHeritageInteractor";

export class TypeHeritageViewModel {
    private interactor: TypeHeritageInteractor;

	constructor() {
		this.interactor = new TypeHeritageInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new TypeHeritageRequest(
            obj["sgeptipopatrimonio"] ? parseInt(obj["sgeptipopatrimonio"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new TypeHeritageStructRequest(
            obj["sgeptipopatrimonio"] ? parseInt(obj["sgeptipopatrimonio"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}